import React from 'react';
import styles from './index.less';
import SegmentedControl from '@tencent/dui/lib/components/SegmentedControl';
import i18n from '@i18next/i18n';
import { E_SELECTED_KEY } from '@src/slide/application/service/change-template-service/index.interface';
import classnames from 'classnames';

interface IDetailHeaderProps {
    selectedTemplateId: string;
    isLoading: boolean;
    showSelectAll: boolean;
    title: string;
    previewMode: E_SELECTED_KEY;
    showUndo: boolean;
    onSelect(key: E_SELECTED_KEY);
    onUndo?();
}

interface IDetailHeaderState {
}
export class DetailHeader extends React.Component<IDetailHeaderProps, IDetailHeaderState> {
    public constructor(props: IDetailHeaderProps) {
        super(props);
    }

    public render() {
        const {
            selectedTemplateId,
            isLoading,
        } = this.props;
        const disabledUndo = !selectedTemplateId || isLoading;
        return <div className={styles['detail-header-container']}>
            <div className={styles['detail-header-title-container']}>
                <div className={styles['detail-header-title-text']}>
                    {
                        this.props.title
                    }
                </div>
                <div className={styles['detail-header-title-button']}>
                    <SegmentedControl
                        style={{
                            width: 112,
                        }}
                        onClick={this.handlePreviewSizeChange}
                        activeId={this.props.previewMode}>
                        <SegmentedControl.Segment
                            id={E_SELECTED_KEY.BIG}>
                            {
                                i18n.t('大图')
                            }
                        </SegmentedControl.Segment>
                        <SegmentedControl.Segment
                            id={E_SELECTED_KEY.SMALL}>
                            {
                                i18n.t('小图')
                            }
                        </SegmentedControl.Segment>
                    </SegmentedControl>
                </div>
            </div>
            {
                this.props.showUndo && <div
                    onClick={() => {
                        if (disabledUndo) return;
                        this.props.onUndo?.();
                    }}
                    className={classnames({
                        [styles['detail-header-undo-container']]: true,
                        [styles.disabled]: disabledUndo,
                    })}>
                    <div className={styles['undo-button']}>
                        <div className={styles['undo-icon']} />
                        <div className={styles['undo-text']}>
                            {
                                i18n.t('全部恢复')
                            }
                        </div>
                    </div>
                </div>
            }
        </div>;
    }

    private handlePreviewSizeChange = (e: React.MouseEvent, selectedKey: E_SELECTED_KEY) => {
        this.setState({
            selectedKey,
        });
        this.props.onSelect(selectedKey);
    };
}
